import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, Globe } from "lucide-react";
import { LINKS } from "../data/content";

export default function Enlaces() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-cyan-700 transition mb-8 text-sm">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-50 text-cyan-700 text-sm font-medium mb-4">
          <Globe size={16} /> Enlaces recomendados
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Recursos de salud mental
        </h1>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto">
          Sitios web de organizaciones profesionales, instituciones de salud y recursos para pacientes y familiares.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {LINKS.map((l, i) => (
          <a
            key={i}
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-lg hover:border-cyan-200 transition-all"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-100 to-teal-100 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <Globe className="text-cyan-700" size={22} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <h3 className="font-bold text-slate-900 group-hover:text-cyan-700 transition line-clamp-1">
                    {l.name}
                  </h3>
                  <ExternalLink size={16} className="text-slate-400 group-hover:text-cyan-600 transition flex-shrink-0" />
                </div>
                <p className="text-slate-600 text-sm">{l.description}</p>
                <p className="text-cyan-600 text-xs mt-2 font-medium line-clamp-1">{l.url}</p>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-12 bg-slate-100 rounded-2xl p-6 text-center">
        <p className="text-sm text-slate-600">
          ⚠️ Los enlaces externos son solo con fines informativos. No reemplazan la consulta médica profesional.
        </p>
      </div>
    </div>
  );
}
